import React from 'react';

const Vue_Methods = () => {
  return (
    <div>
      <h1>Vue_Methods Component</h1>
      <p>This is the Vue_Methods tutorial page.</p>
    </div>
  );
}

export default Vue_Methods;
